
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import RatingStars from '~/components/sections/rating/RatingStars.vue'
import { AgeGroup } from '~/core/offer.types'

@Component({
  components: {
    RatingStars,
  },
})

export default class ReviewGridItem extends Vue {
  @Prop({ required: true }) readonly review!: any

  get servicesAsString () {
    return this.review.services.join(' | ')
  }

  get ageGroup () {
    const ageGroup = this.review.age_group as keyof typeof AgeGroup

    return AgeGroup[ageGroup]
  }
}
